import { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";  
export default function NamosHeader() {
  const [scrolled, setScrolled] = useState(false);


const navigate = useNavigate()
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 flex items-center justify-between px-6 md:px-12 py-3 transition-all duration-300 ${
        scrolled ? "backdrop-blur-sm" : "bg-transparent"
      }`}
    >
      {/* Left Logo */}
      <div className="flex flex-col items-center">
        <img src="/logo.svg" alt="Nammos Logo" className="h-8 md:h-10 w-auto" />
       </div>

      {/* Center Text */}
      <div className="hidden md:block text-md font-saol font-bold tracking-wide">
        NAMMOS DUBAI
      </div>

      {/* Right Side: Reservations & Menu */}
      <div className="flex items-center space-x-4">
        <button onClick={()=>navigate('/date')} className="border border-black font-saol text-black px-8 py-3 text-xs font-normal hover:bg-black hover:text-white transition">
          RESERVATIONS
        </button>
        
      </div>
    </header>
  );
}
